import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-sidebar-toolbar',
  templateUrl: './sidebar-toolbar.component.html',
  styleUrls: ['./sidebar-toolbar.component.scss']
})
export class SidebarToolbarComponent {

  @Output() back = new EventEmitter<void>();

}
